import React, { useEffect } from 'react';

import { IBringgUuids } from '@rbi-ctg/frontend';
import { IServerOrder } from '@rbi-ctg/menu';
import { useDeliveryConfirmationContext } from 'state/delivery-confirmation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';

import { useOrderConfirmationMap } from './use-order-confirmation-map';

export const Map: React.FC<{ bringgUuids?: IBringgUuids; serverOrder: IServerOrder }> = ({
  bringgUuids = {},
  serverOrder,
}) => {
  const { store } = useStoreContext();

  const enableDeliveryWatchDriverLocation = useFlag(
    LaunchDarklyFlag.ENABLE_DELIVERY_WATCH_DRIVER_LOCATION
  );

  const { setDriver } = useDeliveryConfirmationContext();

  const map = useOrderConfirmationMap({
    bringgUuids,
    enableDriverLocation: enableDeliveryWatchDriverLocation,
    serverOrder,
    store,
  });

  useEffect(() => {
    return () => {
      setDriver(null);
    };
  }, [setDriver]);

  return map;
};
